import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SpaceType from '../space-type/SpaceType';
import ListingDetails from '../listing-details/ListingDetails';
import CleaningBadge from '../listing-details/CleaningBadge';
import LinkWrap from '../link-wrap/LinkWrap';
import InstaBook from '../insta-book/InstaBook';
import ViewListingLink from '../view-listing-link/ViewListingLink';
import Responsiveness from '../responsiveness/Responsiveness';
import Description from '../description/Description';

class InfoBox extends Component {
  render () {
    const {
      listing: {
        title,
        review_count,
        review_stars,
        number_guests,
        neighborhood,
        city,
        has_enhanced_cleaning
      },
      location,
      reviews,
      hideLocation,
      responsiveness = {},
      isMap,
      toggleDescription,
      showInstaBook,
      showCleaningBadge,
      infoBoxClassname = ''
    } = this.props;

    const allowInfoBoxToBeClickable = isMap || toggleDescription;

    const instantBookLine = showInstaBook && <InstaBook />;
    const responsiveLine = responsiveness.show && <Responsiveness {...responsiveness} />;

    const infoContainer = (
      <div className={`InfoBox info-container ${infoBoxClassname}`} style={ showCleaningBadge ? { minHeight: "146px"} : {}}>
        <h6 className="listing-title">{ title }</h6>
        <div className="info-row">
          <ListingDetails
            reviewStars={ review_stars }
            reviewCount={ review_count }
            guests={ number_guests }
            location={ location || (neighborhood || city) }
            reviews={ reviews }
            hideLocation={ hideLocation }
          />
          { showCleaningBadge && has_enhanced_cleaning ? <CleaningBadge /> : null}
          { instantBookLine || responsiveLine }
          <Description { ...this.props } />
          <SpaceType { ...this.props } />
          <ViewListingLink {...this.props} />
        </div>
      </div>
    );

    if (allowInfoBoxToBeClickable) {
      return infoContainer;
    }
    return (
      <LinkWrap { ...this.props}>
        { infoContainer }
      </LinkWrap>
    )
  }
}

InfoBox.propTypes = {
  listing: PropTypes.shape({
    title: PropTypes.string.isRequired,
    review_count: PropTypes.string,
    review_stars: PropTypes.string,
    neighborhood: PropTypes.string,
    city: PropTypes.string
  }),
  location: PropTypes.string,
  reviews: PropTypes.bool,
  responsiveness: PropTypes.shape({
    show: PropTypes.bool,
    bucket: PropTypes.string
  }),
  listingURL: PropTypes.string,
  showInstaBook: PropTypes.bool
};

export default InfoBox;
